import { Formio } from '@formio/react';

import framework from './framework';

import './framework/templates/defs.css';
import './framework/templates/coreQuestionnaire/styles.css';
import './framework/templates/coreQuestionnaire/choices.css';
import './framework/templates/dailySurvey/styles.css';

Formio.use(framework);
